import React, { useEffect, useMemo, useState } from 'react'
import { districtChange, getAllcountriesList, getAllstates } from '../../UserRegistration/Apis/userSignUpApis'
import { useDispatch, useSelector } from 'react-redux'
import { addShippingAddress, getOrderSummary, getShippingAddress, makePhonePayPayment } from '../../../../../utils/cartSlice'
import { checkOutFormFields } from '../constants'
import { getUserFromLocalStorage } from '../../../../../utils/utils'
import { useNavigate } from 'react-router-dom'
import { debounce } from '@mui/material'
import {
	validateAddressLine1,
	validateAddressLine2,
	validateCity,
	validateEmail,
	validateLandmark,
	validateMobile,
	validateName,
	validatePincode,
} from '../../User/MyAccount/functions/validationFunctions'
import { deleteShippingAddress, setDefaultAddress, updateShippingAddress } from '../../../../../utils/commonSlice'
import { useLocation } from 'react-router-dom'
import toast from 'react-hot-toast'
import { getUserWithdrawlMiscellanous } from '../../User/Withdrawl/Apis/WithdrawlSlice'

const withCheckoutForm = (WrappedComponent) => {
	return (props) => {
		let { userShippingAddress, orderSummary, cart, totalAmount, phonePayPopUpLocation, transactioFeeValue } = useSelector((state) => state.cart)
		const { defaultAddressData, updateAddressData } = useSelector((state) => state.login)
		const { userWithdrawlMiscellanousData } = useSelector((state) => state.withdrawl)
		const [countries, setCountries] = useState([])
		const [allStates, setAllState] = useState([])
		const dispatch = useDispatch()
		const navigate = useNavigate()
		const user = getUserFromLocalStorage()
		const [allDistricts, setAllDistricts] = useState([])
		const [formData, setFormData] = useState({
			...checkOutFormFields,
		})
		const [errors, setErrors] = useState({})
		const [isEditMode, setIsEditMode] = useState(false)
		const [isPayNowEnabled, setPayNowEnabled] = useState(false)
		// Automatically select the default address if one is present
		useEffect(() => {
			if (userShippingAddress && userShippingAddress.length > 0) {
				const defaultAddress = userShippingAddress.find((address) => address.defaultAddress)
				if (defaultAddress) {
					setFormData((prevData) => ({
						...prevData,
						selectedAddress: defaultAddress._id,
					}))
				} else {
					setFormData((prevData) => ({
						...prevData,
						selectedAddress: userShippingAddress[0]._id,
					}))
				}
			}
		}, [userShippingAddress])

		useEffect(() => {
			dispatch(getUserWithdrawlMiscellanous())
		}, [])

		const location = useLocation() // Use useLocation to access state
		const [paymentMethodSelected, setPaymentMethodSelected] = useState([])
		const [salarPayOptions, setSalarPayOptions] = useState({})
		const [salarPayOrder, setSalarPayOrder] = useState([])
		const [selectedPaymentMethods, setSelectedPaymentMethods] = useState({
			salarPay: false,
			otherPay: false,
		})

		const handlePaymentMethodChange = (method) => {
			if (!formData?.selectedAddress) {
				toast.error('Please select a shipping address')
				return
			}
			const noBankDetails = !userWithdrawlMiscellanousData?.bankDetails ?? false

			const noAadhar = !userWithdrawlMiscellanousData?.bankDetails?.aadharCard ?? false

			if (method === 'salarPay') {
				if (noBankDetails && noAadhar) {
					return toast.error('To use Salar Pay, please update your KYC and bank details.')
				}
			}

			const updatedMethods = {
				...selectedPaymentMethods,
				[method]: !selectedPaymentMethods[method], // Toggle the selected method
			}

			const isSalarPaySelected = updatedMethods.salarPay
			const isOtherPaySelected = updatedMethods.otherPay

			let totalValue = salarPayOrder.reduce((acc, option) => acc + (orderSummary?.[option] ?? 0), 0)

			if (!isSalarPaySelected) {
				setSalarPayOrder([])
			}

			if (isOtherPaySelected) {
				setPayNowEnabled(true)
			} else if (isSalarPaySelected) {
				setPayNowEnabled(totalValue >= finalAmount)
			} else {
				// Both methods are unselected
				setPayNowEnabled(false)
				setSalarPayOrder([])
			}

			setSelectedPaymentMethods(updatedMethods)
		}

		const handleAccordionChange = (accordionType) => {
			// Scroll to the bottom of the page when an accordion is opened
			window.scrollTo({
				top: document.documentElement.scrollHeight,
				behavior: 'smooth',
			})
		}

		const handleSalarPayOptionChange = (option) => {
			setSalarPayOptions((prevOptions) => {
				let newOrder = [...salarPayOrder]
				const newOptions = { ...prevOptions }

				if (prevOptions[option]) {
					// If the option is being deselected
					delete newOptions[option]
					newOrder = newOrder.filter((item) => item !== option)
				} else {
					// If the option is being selected
					newOptions[option] = true
					newOrder = [...newOrder.filter((item) => item !== option), option]
				}
				let totalValue = 0
				// Reconstruct the object based on the new order
				const orderedOptions = {}
				newOrder.forEach((key) => {
					if (newOptions[key]) {
						orderedOptions[key] = true
					}
				})
				newOrder.map((option) => (totalValue += orderSummary?.[option]))
				if (paymentMethodSelected.includes('otherPay') || totalValue >= finalAmount) {
					setPayNowEnabled(true)
				} else {
					setPayNowEnabled(false)
				}
				// const isPayNowEnabled = formData.selectedAddress && paymentMethodSelected.length > 0

				// Update the order state
				setSalarPayOrder(newOrder)

				return orderedOptions
			})

			// If no option is provided (e.g., reset logic), ensure the state is cleared
			if (!option) {
				setSalarPayOptions({})
				setSalarPayOrder([])
			}
		}

		useEffect(() => {
			getAllcountriesList(setCountries)
			if (location.state?.address) {
				const address = location.state.address

				if (address) {
					if (address.countryId?._id) {
						getAllstates(address.countryId?._id, setAllState)
					}
					if (address.districtId?._id) {
						districtChange(address.stateId?._id, setAllDistricts)
					}
				}
				setFormData({
					name: address.name,
					addressLine1: address.addressLine1,
					addressLine2: address.addressLine2,
					city: address.city,
					zipCode: address.zipCode,
					mobileNo: address.mobileNo,
					emailId: address.emailId,
					landmark: address.landmark,
					stateId: address.stateId?._id || '',
					districtId: address.districtId?._id || '',
					countryId: address.countryId?._id || '',
				})
				setIsEditMode(true)
			}
		}, [location.state])

		const validateField = useMemo(
			() =>
				debounce((name, value) => {
					let error = null
					switch (name) {
						case 'name':
							error = validateName(value) ? null : 'Only alphabets with single spaces allowed (max 50 characters)'
							break
						case 'emailId':
							error = validateEmail(value)
								? null
								: 'Only Onee Special character  allowed  "@" , "." , and max words limit - 30, Numeric max limit DIGITS  - 6'
							break
						case 'mobileNo':
							error = validateMobile(value)
								? null
								: 'Invalid mobile number. Must be 10 digits, contain only numbers, and not be all zeros.'
							break
						case 'addressLine1':
							error = validateAddressLine1(value) ? null : 'AlphaNumeric and Special characters " - , / , _ " only with max legth 100'
							break
						case 'addressLine2':
							error = validateAddressLine2(value) ? null : 'AlphaNumeric and Special characters " - , / , _ " only with max legth 100'
							break
						case 'landmark':
							error = validateLandmark(value) ? null : 'Only "Alphabet" with "Single Space" - words limit 30, No Special Characters '
							break
						case 'city':
							error = validateCity(value) ? null : 'One Space allowed, only Alphabet, max words limit - 15'
							break
						case 'zipCode':
							const isIndia = formData.countryId === 'India'

							// Perform pincode validation
							if (isIndia) {
								if (value) {
									if (value === '000000') {
										error = 'Invalid pincode. Cannot be 000000.'
									} else if (!validatePincode(value, isIndia)) {
										error = 'Invalid pincode. Must be 6 digits and not 000000.'
									} else {
										error = null
									}
								}
							} else {
								error = validatePincode(value, isIndia) ? null : 'Invalid pincode. Must be numeric, up to 6 characters.'
							}
						default:
							break
					}
					setErrors((prevErrors) => ({
						...prevErrors,
						[name]: error,
					}))
				}, 300),
			[formData.countryId]
		)

		const handleInputChange = (e) => {
			const { name, value } = e.target
			setFormData((prevData) => ({
				...prevData,
				[name]: value,
			}))
			validateField(name, value)
			if (name === 'selectedAddress' && !selectedPaymentMethods?.otherPay && !selectedPaymentMethods?.salarPay) {
				toast.error('Please select a payment method')
			}
			if (name === 'countryId') {
				if (value) {
					getAllstates(value, setAllState)
				} else {
					setFormData((prevData) => ({
						...prevData,
						stateId: '',
						districtId: '',
					}))
					setAllState([]) // Clear states
					setAllDistricts([]) // Clear districts
				}
			} else if (name === 'stateId') {
				if (value) {
					districtChange(value, setAllDistricts)
				} else {
					setFormData((prevData) => ({
						...prevData,
						districtId: '',
					}))
					setAllDistricts([]) // Clear districts
				}
			}
		}
		const isFormValid = () => {
			const requiredFields = ['name', 'mobileNo', 'emailId', 'addressLine1', 'city', 'zipCode', 'countryId', 'stateId', 'districtId']
			return requiredFields.every((field) => formData[field] && !errors[field])
		}
		const handleaddressSubmit = async (e) => {
			e.preventDefault()
			try {
				if (isEditMode) {
					const addressId = location.state?.address?._id
					await dispatch(updateShippingAddress({ ...formData, addressId }))
				} else {
					await dispatch(addShippingAddress(formData))
				}
				await dispatch(getShippingAddress(user?.data?._id))
				navigate('/user/address') // Redirect to address list after successful submission
			} catch (error) {
				console.error('Error during submission:', error)
			}
		}

		useEffect(() => {
			getAllcountriesList(setCountries)
			if (user) {
				dispatch(getShippingAddress(user?.data?._id))
				dispatch(getOrderSummary(user?.data?._id))
			}
		}, [])

		const handleDefaultAddressClick = async (_id) => {
			await dispatch(setDefaultAddress({ addressId: _id }))
			dispatch(getShippingAddress(user?.data?._id))
		}
		const handleDeleteAddressClick = async (_id) => {
			await dispatch(deleteShippingAddress({ addressId: _id }))
			dispatch(getShippingAddress(user?.data?._id))
		}

		const countriesList = countries.map((country) => ({
			value: country._id,
			label: country.name,
		}))
		const statesList = allStates
			.map((state) => ({
				value: state._id,
				label: state.name,
			}))
			.sort((a, b) => a.label.localeCompare(b.label))
		const districtList = allDistricts.map((dis) => ({
			value: dis._id,
			label: dis.name,
		}))
		// const isPayNowEnabled = formData.selectedAddress && paymentMethodSelected.length > 0

		const handlePayNow = async (e) => {
			e.preventDefault()
			if (isPayNowEnabled) {
				let paymentMethods = []
				if (paymentMethodSelected.includes('salarPay')) {
					salarPayOrder.forEach((option) => {
						if (salarPayOptions[option]) {
							paymentMethods.push({ method: option })
						}
					})
				}

				if (paymentMethodSelected.includes('otherPay')) {
					paymentMethods.push({ method: 'onlinePayment' })
				}

				const body = {
					paymentMethods: paymentMethods,
					addressId: formData?.selectedAddress,
				}
				try {
					const res = await dispatch(makePhonePayPayment(body))
					if (res?.payload?.status === 1 && res?.payload?.data?.paymentURL) {
						window.location.href = phonePayPopUpLocation ?? res?.payload?.data?.paymentURL
					} else if (res?.payload?.status === 1) {
						navigate('/paymentSuccessfull')
					} else {
						navigate('/paymentFailed')
					}
				} catch (error) {
					// Log the error for debugging
					console.error('Payment error:', error)

					// Redirect to the payment failed page if an error occurs
					navigate('/paymentFailed')
				}
			}
		}

		const [error, setError] = useState(null) // For handling errors
		const [finalAmount, setFinalAmount] = useState(totalAmount)
		const [remainingAmount, setRemainingAmount] = useState(totalAmount)

		const [transactionFee, setTransactionFee] = useState(0)
		const hasSelectedPaymentMethod = paymentMethodSelected && paymentMethodSelected.length > 0
		const shouldShowTransFee = paymentMethodSelected?.includes('otherPay')

		useEffect(() => {
			// Step 1: Initialize total deduction
			let totalDeduction = 0
			// Step 2: Calculate the total deduction for each payment method without throwing errors yet
			if (salarPayOptions.shoppingAmount) {
				totalDeduction += Math.min(orderSummary?.shoppingAmount || 0, orderSummary?.cartTotal)
			}

			if (salarPayOptions.gameCommission) {
				totalDeduction += Math.min(orderSummary?.gameCommission || 0, orderSummary?.cartTotal - totalDeduction)
			}

			if (salarPayOptions.sponserCommission) {
				totalDeduction += Math.min(orderSummary?.sponserCommission || 0, orderSummary?.cartTotal - totalDeduction)
			}

			if (salarPayOptions.ausCommission) {
				totalDeduction += Math.min(orderSummary?.ausCommission || 0, orderSummary?.cartTotal - totalDeduction)
			}
			if (salarPayOptions.prtCommission) {
				totalDeduction += Math.min(orderSummary?.prtCommission || 0, orderSummary?.cartTotal - totalDeduction)
			}

			if (salarPayOptions.salarCoins) {
				totalDeduction += Math.min(orderSummary?.salarCoins || 0, orderSummary?.cartTotal - totalDeduction)
			}

			if (salarPayOptions.funds) {
				totalDeduction += Math.min(orderSummary?.funds || 0, orderSummary?.cartTotal - totalDeduction)
			}

			if (salarPayOptions.wallet) {
				totalDeduction += Math.min(orderSummary?.wallet || 0, orderSummary?.cartTotal - totalDeduction)
			}

			// Step 3: Now check if any payment method selection causes the total to exceed the cart total
			if (totalDeduction > orderSummary?.cartTotal) {
				setError('The selected payment methods exceed the cart total. Please adjust your selection.')
				return // Return early to prevent further calculations
			}

			// Step 4: Calculate remaining amount to be paid via other methods (if applicable)
			let remainingAmount = orderSummary?.cartTotal - Math.max(totalDeduction, 0)

			// Step 5: Calculate transaction fee
			const gstMultiplier = 1 + (orderSummary?.transactionFeeLocalGST || 0) / 100 // GST multiplier

			const transactionFee = shouldShowTransFee ? remainingAmount * transactioFeeValue * gstMultiplier : 0

			// Step 6: Calculate final amount
			const finalAmount = orderSummary?.cartTotal + transactionFee
			setRemainingAmount(remainingAmount)
			// Step 7: Update state values
			setTransactionFee(transactionFee)
			setFinalAmount(finalAmount)

			// Step 7: Clear error if everything is valid
			setError(null)
		}, [salarPayOptions, shouldShowTransFee, orderSummary?.cartTotal, transactioFeeValue])

		useEffect(() => {
			const selectedMethods = Object.entries(selectedPaymentMethods)
				.filter(([_, isSelected]) => isSelected)
				.map(([method]) => method)
			setPaymentMethodSelected(selectedMethods)
		}, [selectedPaymentMethods, setPaymentMethodSelected])

		const handleSubmit = async (e) => {
			e.preventDefault()
			await dispatch(addShippingAddress(formData))
			await dispatch(getShippingAddress(user?.data?._id))
			setFormData(checkOutFormFields)
		}

		return (
			<WrappedComponent
				{...props}
				formData={formData}
				handleInputChange={handleInputChange}
				handleSubmit={handleSubmit}
				countriesList={countriesList}
				statesList={statesList}
				districtList={districtList}
				userShippingAddress={userShippingAddress}
				orderSummary={orderSummary}
				errors={errors}
				isFormValid={isFormValid}
				defaultAddressData={defaultAddressData}
				handleDefaultAddressClick={handleDefaultAddressClick}
				handleaddressSubmit={handleaddressSubmit}
				updateAddressData={updateAddressData}
				isEditMode={isEditMode}
				handleDeleteAddressClick={handleDeleteAddressClick}
				cart={cart}
				selectedPaymentMethods={selectedPaymentMethods}
				handlePaymentMethodChange={handlePaymentMethodChange}
				salarPayOptions={salarPayOptions}
				handleSalarPayOptionChange={handleSalarPayOptionChange}
				isPayNowEnabled={isPayNowEnabled}
				handlePayNow={handlePayNow}
				hasSelectedPaymentMethod={hasSelectedPaymentMethod}
				error={error}
				shouldShowTransFee={shouldShowTransFee}
				finalAmount={finalAmount}
				transactionFee={transactionFee}
				onAccordionChange={handleAccordionChange}
				remainingAmount={remainingAmount}
				userWithdrawlMiscellanousData={userWithdrawlMiscellanousData}
			/>
		)
	}
}

export default withCheckoutForm
